module.exports = __webpack_public_path__ + "images/android_app_wall_dash-min.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/android_app_wall_dash-min.png
 ** module id = 2408
 ** module chunks = 3
 **/